import { useMemo } from 'react';

import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import { LightTooltip } from 'components';
import { EntityType } from 'enums';
import { UserBrandEntity, UserSchoolEntity } from 'generated';
import { useBootstrapApp } from 'hooks';

// TODO: ver depois
// import { LowConsistency } from './components';
import { useStyles } from './styles';

interface EntityDescriptionProps {
  entity: UserBrandEntity | UserSchoolEntity;
}
export function EntityDescription({
  entity,
}: EntityDescriptionProps): JSX.Element {
  const { rootStyle, entityTitleStyle, skeleton } = useStyles();
  const { entityType, globalLoading } = useBootstrapApp();

  const memoIsCompany = useMemo(() => {
    return entityType === EntityType.COMPANY;
  }, [entityType]);

  return (
    <div className={rootStyle}>
      {globalLoading ? (
        <Skeleton className={skeleton} width={250} height={20} />
      ) : (
        <>
          <LightTooltip
            title={memoIsCompany ? entity?.id : entity?.name}
            placement="top"
          >
            <Typography noWrap className={entityTitleStyle}>
              {memoIsCompany ? entity?.id : entity?.name}
            </Typography>
          </LightTooltip>
          {/* TODO: ver depois */}
          {/* {!entity?.consistency && <LowConsistency />} */}
        </>
      )}
    </div>
  );
}
